import React from 'react';
import { Box, Typography } from '@mui/material';

const UserProfileSummary = ({ user, sx = {} }) => (
  <Box
    sx={{
      p: 2,
      backgroundColor: '#f5f5f5',
      borderRadius: 2,
      ...sx
    }}
  >
    <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
      {user?.name || 'User'}
    </Typography>
    <Typography variant="body2" color="text.secondary">
      {user?.email || 'user@example.com'}
    </Typography>
  </Box>
);

export default UserProfileSummary;
